// Generated by tools/icons/generate.mjs. Edit the SVG source and manifest instead.
import * as React from "react"
const ChevronDownIcon = /* @__PURE__ */ React.forwardRef<SVGSVGElement, React.ComponentProps<"svg">>((props, ref) => {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.96967 9.96967C7.26256 9.67678 7.73744 9.67678 8.03033 9.96967L12.0303 13.9697C12.1793 14.1186 12.4207 14.1186 12.5697 13.9697L16.5697 9.96967C16.8626 9.67678 17.3374 9.67678 17.6303 9.96967C17.9232 10.2626 17.9232 10.7374 17.6303 11.0303L13.6303 15.0303C12.8956 15.7651 11.7044 15.7651 10.9697 15.0303L6.96967 11.0303C6.67678 10.7374 6.67678 10.2626 6.96967 9.96967Z"
        fill="currentColor"
      />
    </svg>
  )
})
ChevronDownIcon.displayName = "ChevronDownIcon"
export { ChevronDownIcon }
